import LvCollapsible from './Collapsible.vue';
export default LvCollapsible;
